import { User } from "@acto/taskpane/core/domain";

/**
 * Whether [user] is the signed-in [viewerId]. An absent user or an unresolved viewer counts as the
 * viewer's own.
 */
export function belongsToViewer(user: User | null | undefined, viewerId?: string): boolean {
  if (!user || !viewerId) return true;

  return user.id === viewerId;
}

export function otherUserName(user: User | null | undefined, viewerId?: string): string | null {
  return belongsToViewer(user, viewerId) ? null : (user?.displayName ?? null);
}
